import React from 'react';
import styled from 'styled-components';
import MyRadioButton from 'components/controls/MyRadioButton';
import { AdminCompanySearchResultItem } from 'types/admin-search-companies/AdminCompanySearchResultItem';

interface Props {
  companies: AdminCompanySearchResultItem[];
  companyId: string | null;
  onCompanySelected(item: AdminCompanySearchResultItem): void;
}

const AdminEditToolHeadCompanySelectorFormResults: React.FC<Props> = ({ companies, companyId, onCompanySelected }) => {
  return companies.map((c) => (
    <CompanyItem key={c.id} onClick={() => onCompanySelected(c)}>
      <CompanyName>{c.name || '<N/A>'}</CompanyName>
      <MyRadioButton
        inputId={c.id}
        value={c.id}
        name="companyItem"
        checked={companyId === c.id}
        onChange={() => onCompanySelected(c)}
      />
    </CompanyItem>
  ));
};

export default AdminEditToolHeadCompanySelectorFormResults;

const CompanyItem = styled.button`
  all: unset;
  min-height: 50px;
  box-sizing: border-box;
  padding: 12px 16px;
  cursor: pointer;
  border: 1px solid ${(props) => props.theme.colors.elementsInputBorder};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const CompanyName = styled.span`
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
`;
